/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_SharingInputs */

const en_story_sharing = /** @type {(inputs: Story_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing...`)
};

const es_story_sharing = /** @type {(inputs: Story_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartiendo...`)
};

const fr_story_sharing = /** @type {(inputs: Story_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partage...`)
};

const de_story_sharing = /** @type {(inputs: Story_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen...`)
};

const id_story_sharing = /** @type {(inputs: Story_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membagikan...`)
};

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const ja_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const zh_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const ar_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const it_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const ru_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const pt_story_sharing = en_story_sharing;

/** @type {(inputs: Story_SharingInputs) => LocalizedString} */
const ko_story_sharing = en_story_sharing;

/**
* | output |
* | --- |
* | "Sharing..." |
*
* @param {Story_SharingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_sharing = /** @type {((inputs?: Story_SharingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_SharingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_sharing(inputs)
	if (locale === "es") return es_story_sharing(inputs)
	if (locale === "fr") return fr_story_sharing(inputs)
	if (locale === "de") return de_story_sharing(inputs)
	if (locale === "ja") return ja_story_sharing(inputs)
	if (locale === "zh") return zh_story_sharing(inputs)
	if (locale === "ar") return ar_story_sharing(inputs)
	if (locale === "id") return id_story_sharing(inputs)
	if (locale === "it") return it_story_sharing(inputs)
	if (locale === "ru") return ru_story_sharing(inputs)
	if (locale === "pt") return pt_story_sharing(inputs)
	return ko_story_sharing(inputs)
});